import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsWebsites(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá vývoj a spuštění webu na míru?",
			answer:
				"Doba vývoje záleží na řadě faktorů, například na jeho rozsahu a náročnosti řešení. Nejrychlejší weby s administrací na míru zvládneme do 1 měsíce, průměrně tvorba zabere kolem 3 měsíců (MVP verze).",
		},
		{
			question: "Jak probíhá komunikace během projektu?",
			answer:
				"V posledních letech se nám i našim klientům nejvíce osvědčila online komunikace, využíváme k ní nástroje jako Slack nebo Google Meet. Projektové řízení pak probíhá pomocí softwaru Jira. K základní komunikaci samozřejmě využíváme i e-mail.",
		},
		{
			question: "Jak testujete kvalitu a funkčnost webu před jeho spuštěním?",
			answer:
				"Na testování webu máme několik postupů a scénářů, které v čase aktualizujeme. Používáme běžné uživatelské manuální testy, emulátory i automatizované testy v kódu.",
		},
		{
			question: "Můžeme si vybrat vlastní design webu?",
			answer:
				"Pokud chcete, můžeme na návrhu webu spolupracovat s vaším grafikem. Rádi vám ale dodáme naše ověřené specialisty na grafický design, většinou jde o profesionály na volné noze nebo z agentur.",
		},
		{
			question: "Je možné integrovat web se stávajícími systémy (např. ERP a CRM)?",
			answer: "Ano, stačí, aby váš systém nebyl uzavřený a fungoval, například by měl mít funkční API.",
		},
		{
			question: "Jak zajistíte, aby byl web bezpečený a chráněný před kybernetickými útoky?",
			answer:
				"Bezpečnost je pro nás prioritou. Používáme serveless architekturu, která vznik útoků buď kompletně znemožňuje, nebo je dokáže výrazně omezit.",
		},
		{
			question: "Kolik stojí tvorba webu na míru?",
			answer:
				"Cena jednoduchý webů se nejčastěji pohybuje v rozmezí 150–500 tisíc Kč. Středně velké pak stojí kolem 300–750 tisíc Kč, náročné a rozsáhlé kolem 1 milionu Kč. Všechny zakázky naceňujeme individuálně.",
		},
		{
			question: "Můžeme mít přístup k administraci a spravovat si web sami?",
			answer: "Ano, pokud budete chtít, vytvoříme vám administraci na míru.",
		},
		{
			question: "Jak zajistíte, že web bude rychlý a výkonný?",
			answer:
				"Rychlost a vysoký výkon webů jsou naše doména. Programujeme s důrazem na rychlost načítání a uživatelskou přívětivost. Tak, aby web měli rádi návštěvníci i indexovací roboti.",
		},
	];
}
